import React from 'react';
import { flag } from 'hocs/WithFeatureFlag';
import { AnalyticsTypes, ISidebarItem, MENU_ITEMS, MENU_ROUTE_PARAM, TagManagerTypes } from './types.d';

export const SideItems: Array<ISidebarItem> = [
  {
    key: MENU_ITEMS.USERS,
    name: 'Usuários',
    routeParam: MENU_ROUTE_PARAM.USERS,
    icon: <i className="fa-regular fa-user-headset" />,
  },
  {
    key: MENU_ITEMS.TEAMS,
    name: 'Equipes',
    routeParam: MENU_ROUTE_PARAM.TEAMS,
    icon: <i className="fa-regular fa-users" />,
  },
  {
    key: MENU_ITEMS.CONVERSATIONS,
    name: 'Conversas',
    routeParam: MENU_ROUTE_PARAM.CONVERSATIONS,
    icon: <i className="fa-regular fa-comments" />,
  },
  {
    key: MENU_ITEMS.CUSTOM_FIELDS,
    name: 'Campos personalizados',
    routeParam: MENU_ROUTE_PARAM.CUSTOM_FIELDS,
    icon: <i className="fa-solid fa-input-text" />,
  },
  {
    key: MENU_ITEMS.CANNED_MESSAGES,
    name: 'Mensagens modelo',
    routeParam: MENU_ROUTE_PARAM.CANNED_MESSAGES,
    icon: <i className="fa-regular fa-square-bolt" />,
  },
  {
    key: MENU_ITEMS.TAGS,
    name: 'Etiquetas',
    routeParam: MENU_ROUTE_PARAM.TAGS,
    icon: <i className="fa-regular fa-tags" />,
    skipSubItemRedirect: false,
    subItems: [
      {
        key: MENU_ITEMS.TAGS_CONTACT,
        name: 'Etiquetas de contato',
        routeParam: MENU_ROUTE_PARAM.TAGS_CONTACT,
        type: TagManagerTypes.VISITOR,
      },
      {
        key: MENU_ITEMS.TAGS_ROOM,
        name: 'Etiquetas de conversa',
        routeParam: MENU_ROUTE_PARAM.TAGS_ROOM,
        type: TagManagerTypes.ROOM,
      },
    ],
  },
  {
    key: MENU_ITEMS.ANALYTICS,
    name: 'Analytics',
    routeParam: MENU_ROUTE_PARAM.ANALYTICS,
    icon: <i className="fa-solid fa-chart-mixed" />,
    skipSubItemRedirect: false,
    subItems: [
      {
        key: MENU_ITEMS.OVERVIEW,
        name: 'Overview',
        routeParam: MENU_ROUTE_PARAM.OVERVIEW,
        type: AnalyticsTypes.OVERVIEW,
      },
      {
        key: MENU_ITEMS.SALESDESK_PERFORMANCE,
        name: 'Team performance',
        routeParam: MENU_ROUTE_PARAM.SALESDESK_PERFORMANCE,
        type: AnalyticsTypes.SALESDESK_PERFORMANCE,
      },
      {
        key: MENU_ITEMS.AGENTS_PERFORMANCE,
        name: 'Agent performance',
        routeParam: MENU_ROUTE_PARAM.AGENTS_PERFORMANCE,
        type: AnalyticsTypes.AGENTS_PERFORMANCE,
      },
      {
        key: MENU_ITEMS.CSAT,
        name: 'CSAT',
        routeParam: MENU_ROUTE_PARAM.CSAT,
        type: AnalyticsTypes.CSAT_SALESDESK,
      },
    ],
  },
  {
    key: MENU_ITEMS.VERIFIED_TEMPLATES,
    name: 'Templates verificados',
    routeParam: MENU_ROUTE_PARAM.VERIFIED_TEMPLATES,
    icon: <i className="fa-regular fa-badge-check" />,
  },
  {
    key: MENU_ITEMS.CHAT_COPILOT_ASSISTANT,
    featureFlagName: flag.CHAT_COPILOT_ASSISTANT,
    name: 'Suggested Messages',
    routeParam: MENU_ROUTE_PARAM.CHAT_COPILOT_ASSISTANT,
    icon: <i className="fa-solid fa-lightbulb" />,
  },
  {
    key: MENU_ITEMS.BUSINESS_HOURS,
    featureFlagName: flag.BUSINESS_HOURS,
    name: 'Business hours',
    routeParam: MENU_ROUTE_PARAM.BUSINESS_HOURS,
    icon: <i className="fa-regular fa-clock" />,
  },
];
